import ModalDialog, {
  ModalCloseHandler,
  ModalCloseReason,
} from 'src/components/ModalDialog';
import { useForm } from 'src/components/Form';
import { useAlert, AlertType } from 'src/components/AlertsProvider';
import { pepApiRequest, RequestMethod, useStatefulApi } from 'src/services';
import { generatePath, useParams } from 'react-router-dom';
import { useStoreUnitActions } from 'src/redux/helpers';
import { SolutionGroupItem } from '../../types';
import { API_SOLUTION_GROUP_POST } from '../../constants';
import { solutionGroupsFormFields } from '../formFields';
import solutionsStore from '../../redux';

type Props = {
  item: SolutionGroupItem;
  open: boolean;
  onClose: ModalCloseHandler;
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
};

function SolutionGroupsAssignModal({ item, open, onClose }: Props) {
  const { showAlert } = useAlert();
  const { solutionId } = useParams();

  const [onSubmit, loading] = useStatefulApi(
    (params) =>
      pepApiRequest({
        method: RequestMethod.Post,
        url: generatePath(API_SOLUTION_GROUP_POST, { solutionId }),
        params,
      }),
    (params) => {
      showAlert({
        type: AlertType.Success,
        title: 'New group Saved',
        text: `${params.name || ''} group has been created successfully.`,
      });
      onClose(null, ModalCloseReason.completeAction);
    }
  );

  const [form, handleSubmit] = useForm({
    fields: solutionGroupsFormFields(),
    values: item,
    sx: containerStyle,
    onSubmit,
  });

  return (
    <ModalDialog
      open={open}
      title="Create Group"
      loading={loading}
      onClose={onClose}
      onConfirm={handleSubmit}
      confirmBtnText="Create"
    >
      {form}
    </ModalDialog>
  );
}

export default SolutionGroupsAssignModal;
